module.exports = __webpack_public_path__ + "asset/image-expired-72a7f3a2065ed35b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/identity/scene/forgot-password/scene/forgot-password-token-expired/image/expired.svg
// module id = pv2Y
// module chunks = 0